import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import { useAnchorElState } from 'react-use-object-state';

type AnchorHook = ReturnType<typeof useAnchorElState>;

interface QueryExportMenuProps {
  anchor: AnchorHook;
  menuItemClasses: { root: string; selected: string };
  onClickShareLink?: VoidFunction;
  onClickDownloadAsCSV?: VoidFunction;
  onClickDownloadAsJSON?: VoidFunction;
}

const wrapAction = (anchor: AnchorHook, action?: VoidFunction) => () => {
  anchor.clearAnchorEl();
  if (action) {
    action();
  }
};

const QueryExportMenu = ({
  anchor,
  menuItemClasses,
  onClickShareLink,
  onClickDownloadAsCSV,
  onClickDownloadAsJSON,
}: QueryExportMenuProps) => (
  <Menu
    anchorEl={anchor.anchorEl}
    open={Boolean(anchor.anchorEl)}
    onClose={anchor.clearAnchorEl}
  >
    <MenuItem
      classes={menuItemClasses}
      onClick={wrapAction(anchor, onClickShareLink)}
    >
      Share Link
    </MenuItem>
    <MenuItem
      classes={menuItemClasses}
      onClick={wrapAction(anchor, onClickDownloadAsCSV)}
    >
      Download as CSV
    </MenuItem>
    <MenuItem
      classes={menuItemClasses}
      onClick={wrapAction(anchor, onClickDownloadAsJSON)}
    >
      Download as JSON
    </MenuItem>
  </Menu>
);

export default QueryExportMenu;
